import React, {useEffect, useState} from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  makeStyles,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Chip,
  Divider, Button,
} from "@material-ui/core";
import {PieChart, Pie, Tooltip, Legend, Cell} from 'recharts';
import SideDrawer from "../../../Components/Advertisers/SideDrawer";
import CustomText from "../../../Components/Universal/CustomText";
import useAxios from "axios-hooks";
import {getCampaign, getCampaignChartData} from "../../../Api";
import PageLoading from "../../../Components/Advertisers/PageLoading";
import moment from "moment";
import {COLORS} from "./constants";
import {setCustomerListPreset} from "../../../Helpers";


const useStyles = makeStyles(theme => ({
  detailsCard: {
    width: "100%",
  },
}));


const CampaignDetails = ({history, match: { params: { campaignId } }}) => {
  const [{error, loading, data}] = useAxios(getCampaign(campaignId), {manual: false});
  const [{loading: chartLoading, data: chartData}] = useAxios(getCampaignChartData(campaignId), {manual: false});
  const [campaign, setCampaign] = useState({});
  const [chartValues, setChartValues] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    if (data && data.campaign && data.campaign.id) {
      setCampaign(data.campaign);
    }
  }, [data]);

  useEffect(() => {
    if (chartData && chartData.values && chartData.values.length > 0) {
      setChartValues(chartData.values);
    }
  }, [chartData]);

  const handleCustomerListAdd = option => () => {
    setCustomerListPreset({
      inquiry_id: campaign.inquiry_id,
      inquiry_option_name: option
    });
    history.replace('/advertiser/customerlists/create');
  };

  return (
    <SideDrawer>
      <Container>
        <PageLoading show={loading || chartLoading} />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CustomText
              text={`Campaign - ${campaign.id}`}
              style='titleLarge'
              margin='40px 0 0 0'
            />
          </Grid>
          <Grid item md={6}>
            <Card className={classes.detailsCard}>
              <CardContent>
                <Typography component="h5">
                  Question
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  {campaign.questionText}
                </Typography>
                <div>&nbsp;</div>
                <Typography component="h5" mt={3}>
                  Responses requested
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  {campaign.totalResponses}
                </Typography>
                <div>&nbsp;</div>
                <Typography component="h5" mt={3}>
                  Lunch Date
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  {moment(campaign.launchDate).format('MMMM D ha')}
                </Typography>

                <div>&nbsp;</div>
                <Typography component="h5" mt={3}>
                  End Date
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  {campaign.endDate ? moment(campaign.endDate).format('MMMM D ha') : 'Will end when all responses are provided'}
                </Typography>

                <div>&nbsp;</div>
                <Typography component="h5" mt={3}>
                  Response Options
                </Typography>
                <div>&nbsp;</div>
                <List component="nav" aria-label="main mailbox folders">
                  {chartValues && chartValues.map((cv, i) => (
                    [
                      <ListItem key={cv.name}>
                        <ListItemText
                          primary={cv.name}
                        />
                        <ListItemSecondaryAction>
                          <Chip label={`${cv.value} Responses`} />&nbsp;
                          <Button size='small' variant="outlined" onClick={handleCustomerListAdd(cv.name)}>Add customer list</Button>
                        </ListItemSecondaryAction>
                      </ListItem>,
                      (i < chartValues.length - 1 ? <Divider key={cv.id + i} /> : <div key={cv.id + i} /> )
                    ]
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6}>
            {chartValues && chartValues.length > 0 && (
              <PieChart width={500} height={500}>
                <Pie data={chartValues} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={200}>
                  {
                    chartValues.map((entry, index) => <Cell fill={COLORS[index % COLORS.length]}/>)
                  }
                </Pie>
                <Tooltip cursor={false} />
                <Legend layout='vertical' verticalAlign="bottom" align='left' height={70} margin={{ top: 20, bottom: 20 }} />
              </PieChart>
            )}
          </Grid>
        </Grid>
      </Container>
    </SideDrawer>
  )
};


export default CampaignDetails;
